import { Dispatch, SetStateAction, useState } from "react";
import Step1 from "./components/Step1";
import LivePreview from "./components/LivePreview";
import { CheckIcon, TicketIcon } from "lucide-react";
import Step2 from "./components/Step2";
import Step3 from "./components/Step3";

interface CreateBasicProfileProps {
  activeStep: number
}

const CreateBasicProfile = ({
  activeStep,
}: CreateBasicProfileProps) => {

  return (
    <div className="flex flex-1 min-h-0 gap-3.5 w-full">
      {/* Profile setup */}
      {
        activeStep === 1 ?
          <Step1 /> :
          activeStep === 2 ?
            <Step2 /> :
            activeStep === 3 ?
              <Step3 />
              : null
      }
      {/* Live profile preview */}
      <LivePreview />
    </div>
  );
};

export default CreateBasicProfile;
